import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "location" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 4,
  class: "noSuggestions"
}

import { computed, ref } from 'vue';
import { Icon } from '../../Atoms';
import { PortList } from '../../Molecules';
import { RecentOrSuggestedSearchEntry, RecentOrSuggestedSearchEntryGroup } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentSearches',
  props: {
    title: {},
    searches: {},
    showSearches: { type: Boolean },
    showRouteMapButton: { type: Boolean },
    selectRouteMapCallback: {},
    ariaId: {},
    ariaLabeledBy: {},
    showPortCodes: { type: Boolean, default: false },
    noResultsText: { default: 'No suggestions found' },
    showTextCode: { type: Boolean, default: false }
  },
  emits: ['setSearchValue', 'setShowSearches', 'searchClick'],
  setup(__props: any) {

const closeOverlayButtonRef = ref(null);


const props = __props;

const groupedSearches = computed(() => {
  const groups: RecentOrSuggestedSearchEntryGroup[] = [];
  props.searches?.forEach((portList) => {
    if (!groups.find((x) => x.location === portList.location)) {
      groups.push({ location: portList.location, ports: [] } as RecentOrSuggestedSearchEntryGroup);
    }
    const group = groups.find((x) => x.location === portList.location);
    group?.ports.push(portList);
  });

  return groups;
});



return (_ctx: any,_cache: any) => {
  return (_ctx.searches && _ctx.showSearches)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: _ctx.ariaId,
        "aria-labelledby": _ctx.ariaLabeledBy,
        role: "listbox",
        class: _normalizeClass(["searchAutocomplete", {emptyState: _ctx.searches.length === 0 || groupedSearches.value.length === 0}])
      }, [
        (_ctx.showRouteMapButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "routeMapButton",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectRouteMapCallback && _ctx.selectRouteMapCallback(...args)))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Icon), { "icon-name": "mapIconBlack" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Select using route map')), 1)
              ]),
              _createVNode(_unref(Icon), { "icon-name": "link" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.searches.length > 0 || groupedSearches.value.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (_ctx.searches.length > 0 && groupedSearches.value.length === 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searches, (search, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "portPair"
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => {_ctx.$emit('setSearchValue', search);
                  _ctx.$emit('setShowSearches', false);
                  _ctx.$emit('searchClick')}
                  }, [
                    _createVNode(_unref(PortList), {
                      "icon-name": search.iconName,
                      ports: search.ports,
                      "show-port-code": _ctx.showPortCodes,
                      "show-text-code": _ctx.showTextCode,
                      "text-code": search.textCode,
                      class: "listItem"
                    }, null, 8, ["icon-name", "ports", "show-port-code", "show-text-code", "text-code"])
                  ], 8, _hoisted_5)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (groupedSearches.value && groupedSearches.value.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedSearches.value, (group, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", _hoisted_7, _toDisplayString(group.location), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ports, (search, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "portPair"
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => {_ctx.$emit('setSearchValue', search);
                      _ctx.$emit('setShowSearches', false);
                      _ctx.$emit('searchClick')}
                        }, [
                          _createVNode(_unref(PortList), {
                            "icon-name": search.iconName,
                            ports: search.ports,
                            "show-port-code": _ctx.showPortCodes,
                            class: "listItem",
                            "show-text-code": _ctx.showTextCode,
                            "text-code": search.textCode
                          }, null, 8, ["icon-name", "ports", "show-port-code", "show-text-code", "text-code"])
                        ], 8, _hoisted_8)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.noResultsText), 1)),
        _createElementVNode("button", {
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => {_ctx.$emit('setShowSearches', false);}, ["tab"])),
          class: "srOnly"
        }, " Close overlay ", 32)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})